export const CLI_APP_OPTIONS_MODAL_NAME = 'How to start - CLI/App builder';
export const GET_STARTED_WIX_CLI_MODAL_NAME = 'Get started with Wix CLI';
export const CLI_APP_OPTIONS_MODAL_ROUTE = {
    MY_APPS: 'Custom apps',
    TEMPLATES: 'Wix docs - App templates',
};
//# sourceMappingURL=biConstants.js.map